export default __webpack_public_path__ + "static/media/img-005.1f7e6d7a.png";